import React, { useState, useEffect } from "react";
import DeleteModal from "../Assets/DeleteModal";
import { TbEdit } from "react-icons/tb";
import { MdDeleteOutline } from "react-icons/md";
import { db } from "../Config/Firebase";
import {
  collection,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  setDoc,
} from "firebase/firestore";

const Settings = ({ isSidebarCollapsed }) => {
  const [Purposes, setPurposes] = useState([]);
  const [formData, setFormData] = useState({
    configType: "MessageSend",
    coins: "",
    diamond: "",
    amountInINR: "",
    key: "",
  });
  const [editId, setEditId] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  // Fetch config items
  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "config"));
        const plans = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPurposes(plans);
      } catch (error) {
        console.error("Error fetching config items:", error);
      }
    };
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (["amountInINR", "coins", "diamond"].includes(name)) {
      if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
        setFormData((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        const docRef = doc(db, "config", editId);
        await updateDoc(docRef, formData);

        setPurposes((prev) =>
          prev.map((item) =>
            item.id === editId ? { ...item, ...formData } : item
          )
        );
      } else {
        const ids = Purposes.map((p) => Number(p.id)).filter((n) => !isNaN(n));
        const maxId = ids.length ? Math.max(...ids) : 0;
        const newId = (maxId + 1).toString();
        let key = "";
        if (formData.configType === "MessageSend") {
          key = "MALE_MESSAGE_SENT";
          await setDoc(doc(db, "config", newId), {
            configType: formData.configType,
            coins: formData.coins,
            key,
          });
        } else if (formData.configType === "MessageReceive") {
          key = "FEMALE_MESSAGE_RECEIVED";
          await setDoc(doc(db, "config", newId), {
            configType: formData.configType,
            diamond: formData.diamond,
            key,
          });
        } else if (formData.configType === "DiamondWithdraw") {
          key = "DIAMOND_WITHDRAW_RATE";
          await setDoc(doc(db, "config", newId), {
            configType: formData.configType,
            
            diamond: formData.diamond,
            amountInINR: formData.amountInINR,
            key,
          });
        } else if (formData.configType === "MinimumWithdraw") {
          key = "MINIMUM_WITHDRAW_AMOUNT";
          await setDoc(doc(db, "config", newId), {
            configType: formData.configType,
            amountInINR: formData.amountInINR,
            key,
          });
        }

          
        

        setPurposes((prev) => [...prev, { id: newId, ...formData, key }]);
      }

      setFormData({
        configType: "MessageSend",
        coins: "",
        diamond: "",
        amountInINR: "",
        key: "",
      });
      setEditId(null);
    } catch (error) {
      console.error("Error saving config:", error);
    }
  };

  const handleEdit = (id) => {
    const purposeToEdit = Purposes.find((p) => p.id === id);
    if (purposeToEdit) {

      let key = "";
      if (purposeToEdit.configType === "MessageSend") {
          key = "MALE_MESSAGE_SENT";
          setFormData({
            configType: purposeToEdit.configType || "MessageSend",
            coins: purposeToEdit.coins || "",
            key,
          });
        } else if (purposeToEdit.configType === "MessageReceive") {
          key = "FEMALE_MESSAGE_RECEIVED";
          
          setFormData({
            configType: purposeToEdit.configType || "MessageSend",
            
            diamond: purposeToEdit.diamond || "",
            key,
          });
        } else if (purposeToEdit.configType === "DiamondWithdraw") {
          key = "DIAMOND_WITHDRAW_RATE";
          
          setFormData({
            configType: purposeToEdit.configType || "MessageSend",
            
            diamond: purposeToEdit.diamond || "",
            amountInINR: purposeToEdit.amountInINR || "",
            key,
          });
        } else if (purposeToEdit.configType === "MinimumWithdraw") {
          key = "MINIMUM_WITHDRAW_AMOUNT";

          setFormData({
            configType: purposeToEdit.configType || "MessageSend",

            amountInINR: purposeToEdit.amountInINR || "",
            key,
          });
        }

      setEditId(id);
    }
  };

  const cancelEdit = () => {
    setFormData({
      configType: "MessageSend",
      coins: "",
      diamond: "",
      amountInINR: "",
      key: "",
    });
    setEditId(null);
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setDeleteModalShow(true);
  };

  const confirmDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await deleteDoc(doc(db, "config", itemToDelete));
        setPurposes((prev) => prev.filter((item) => item.id !== itemToDelete));
      } catch (error) {
        console.error("Error deleting config item:", error);
      }
    }
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  const cancelDelete = () => {
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  return (
    <div className="coin-settings-container">
      {/* Form Section */}
      <div className="bg-white p-[1vw] coin-settings-form-container">
        <div className="text-[20px] font-bold border-b-1 text-gray-600 border-gray-300 pb-[2px]">
          <h1 className="text-gray-600">
            {editId ? "Update Config Settings" : "Add Config Settings"}
          </h1>
        </div>
        <form className="bg-white pt-1 rounded-lg" onSubmit={handleSubmit}>
          {/* Config Type */}
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Select Config Type *
            </label>
            <select
              name="configType"
              value={formData.configType}
              onChange={handleInputChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
              disabled={editId ? true : false}
            >
              <option value="">Select Option</option>
              <option value="MessageSend">Male Message Send</option>
              <option value="MessageReceive">Female Message Receive</option>
              <option value="DiamondWithdraw">Diamond Withdraw Rate</option>
              <option value="MinimumWithdraw">Minimum Withdraw Amount</option>
            </select>
          </div>

          
          {formData.configType === "MessageSend" && (
            <div className="mb-2">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Coin Deduct *
              </label>
              <input
                name="coins"
                value={formData.coins}
                onChange={handleInputChange}
                type="text"
                placeholder="Enter Coin Deduction"
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                required
                min="0"
              />
            </div>
          )}

          {formData.configType === "MessageReceive" && (
            <div className="mb-2">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Diamond Receive *
              </label>
              <input
                name="diamond"
                value={formData.diamond}
                onChange={handleInputChange}
                type="text"
                placeholder="Enter Diamond Amount"
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                required
                min="0"
              />
            </div>
          )}

          {formData.configType === "DiamondWithdraw" && (
            <>
              <div className="mb-2">
                <label className="block text-gray-700 text-sm font-bold mb-2">
                  Diamond Amount *
                </label>
                <input
                  name="diamond"
                  value={formData.diamond}
                  onChange={handleInputChange}
                  type="text"
                  placeholder="Enter Diamond Amount"
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  required
                  min="0"
                />
              </div>
              <div className="mb-2">
                <label className="block text-gray-700 text-sm font-bold mb-2">
                  Amount (INR) *
                </label>
                <input
                  name="amountInINR"
                  value={formData.amountInINR}
                  onChange={handleInputChange}
                  type="text"
                  placeholder="Enter INR Amount"
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  required
                  min="0"
                />
              </div>
            </>
          )}
          {formData.configType === "MinimumWithdraw" && (
            <div className="mb-2">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Minimum Withdraw Amount *
              </label>
              <input
                name="amountInINR"
                value={formData.amountInINR}
                onChange={handleInputChange}
                type="text"
                placeholder="Enter INR Amount"
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                required
                min="0"
              />
            </div>
          )}

          {/* Buttons */}
          <div className="flex items-center gap-2">
            <button
              type="submit"
              className="bg-blue-500 text-sm hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              {editId ? "Update" : "Save"}
            </button>
            {editId && (
              <button
                type="button"
                onClick={cancelEdit}
                className="bg-gray-500 text-sm hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

      {/* Tables */}
      <ul className="w-full coin-settings-display-container">
        <li className="bg-white p-[1vw]">
          <div className="text-[20px] font-bold pb-[10px]">
            <h1>Config Settings</h1>
          </div>
          <section className="flex flex-col justify-center">
            <div className="h-full">
              <div className="w-full bg-white">
                <div className="overflow-x-auto">
                  <table className="table-auto w-full">
                    <thead className="font-semibold uppercase text-white bg-blue-500">
                      <tr className="grid text-xs grid-cols-5">
                        
                        <th className="p-2 whitespace-nowrap text-left">Key</th>

                        <th className="p-2 whitespace-nowrap text-right">Coins</th>
                        <th className="p-2 whitespace-nowrap text-right">Diamond</th>
                        <th className="p-2 whitespace-nowrap text-right">
                          Amount (INR)
                        </th>
                        <th className="p-2 whitespace-nowrap text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody className="text-sm divide-y divide-gray-100">
                      {Purposes.length > 0 ? (
                        Purposes.map((log) => (
                          <tr className="grid grid-cols-5" key={log.id}>
                            <td className="p-2 text-gray-800 flex items-center gap-1">
                              
                              <span>{log.key|| "N/A"}</span>
                            </td>
                            
                            <td className="p-2 text-right text-gray-800">
                              {log.coins ||  "-"}
                            </td>
                            <td className="p-2 text-right text-gray-800">
                              { log.diamond || "-"}
                            </td>
                            <td className="p-2 text-right text-gray-800">
                              {log.amountInINR || "-"}
                            </td>
                            <td className="p-2">
                              <div className="flex gap-2 justify-center items-center">
                                <button
                                  onClick={() => handleEdit(log.id)}
                                  className="text-blue-500 hover:text-blue-700"
                                  title="Edit"
                                >
                                  <TbEdit
                                    size={isSidebarCollapsed ? 16 : 20}
                                  />
                                </button>
                                <button
                                  onClick={() => handleDeleteClick(log.id)}
                                  className="text-red-500 hover:text-red-700"
                                  title="Delete"
                                >
                                  <MdDeleteOutline
                                    size={isSidebarCollapsed ? 16 : 20}
                                  />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} className="p-2 text-center">
                            No Coin Details added yet
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </li>
      </ul>

      {/* Delete Modal */}
      {deleteModalShow && (
        <DeleteModal
          itemName={
            Purposes.find((p) => p.id === itemToDelete)?.key+ " Config" || "Purpose"
          }
          onClose={cancelDelete}
          onDelete={confirmDelete}
        />
      )}
    </div>
  );
};

export default Settings;
